// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0.0.24/static/js/" + chunkId + "." + "4893479f" + ".chunk.js";
};